import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Toaster } from 'sonner';

import { App } from './app/App';
import './styles/index.css';

const queryClient = new QueryClient({
  // A 30s default staleTime means switching tabs/panels and back re-uses cached data instead of
  // refetching from scratch every time a component remounts; queries whose data changes more
  // often (or must reflect writes immediately) override this with their own staleTime/invalidation.
  defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false, staleTime: 30_000 } },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
      <Toaster position="bottom-right" richColors />
    </QueryClientProvider>
  </StrictMode>,
);
